export const TOOLTIP_WIDTH = 320;
export const TOOLTIP_HEIGHT = 200; // estimated max height
const TOOLTIP_MARGIN = 16;

export const calculateTooltipPosition = (targetRect: DOMRect, portalRect?: DOMRect | null) => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  const combinedRect = portalRect
    ? new DOMRect(
        Math.min(targetRect.left, portalRect.left),
        Math.min(targetRect.top, portalRect.top),
        Math.max(targetRect.right, portalRect.right) - Math.min(targetRect.left, portalRect.left),
        Math.max(targetRect.bottom, portalRect.bottom) - Math.min(targetRect.top, portalRect.top),
      )
    : targetRect;

  const spaceOnRight = screenWidth - combinedRect.right;
  const showOnRight = spaceOnRight >= TOOLTIP_WIDTH + TOOLTIP_MARGIN;

  let tooltipLeft: number;
  let tooltipTop: number;
  let tooltipPosition: 'right' | 'bottom' | 'top';

  if (showOnRight) {
    tooltipPosition = 'right';
    tooltipLeft = combinedRect.right + TOOLTIP_MARGIN;
    tooltipTop = targetRect.top + targetRect.height / 2;
  } else {
    const spaceBelow = screenHeight - combinedRect.bottom;
    const showOnBottom = spaceBelow >= TOOLTIP_HEIGHT + TOOLTIP_MARGIN;

    tooltipPosition = showOnBottom ? 'bottom' : 'top';
    const visibleLeft = Math.max(0, targetRect.left);
    const visibleRight = Math.min(screenWidth, targetRect.right);
    tooltipLeft = (visibleLeft + visibleRight) / 2;
    tooltipTop = showOnBottom ? combinedRect.bottom + TOOLTIP_MARGIN : combinedRect.top - TOOLTIP_MARGIN;
  }

  return { tooltipLeft, tooltipTop, tooltipPosition };
};
